module.exports = __webpack_public_path__ + "img/bando1.4f845790.png";